import React from 'react';
import { Link } from 'react-router-dom';

import { getText } from 'shared/utils/Text';
import { getUrl } from 'shared/utils/urls';

import styles from './index.module.scss';

const LiveInvite = () => (
  <div className={styles.wrapper}>
    <div className={styles.caption}>{getText('page-live-invite-caption')}</div>

    <Link to={getUrl.live()} className={styles.container}>
      <div className={styles.dot} />
      <div className={styles.text}>{getText('page-live-invite-button')}</div>
    </Link>
  </div>
);

export default LiveInvite;
